"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : ERROR MESSAGE : STYLES --------------- ++++++++++ */


var _default = {
  errormessage: {
    opacity: '0',
    display: 'block',
    color: (0, _index.convertHexToRGB)(_index.theme.color.attention.dark.swatch, 50),
    fontSize: (0, _index.pxToEm)(14),
    marginTop: (0, _index.pxToEm)(5),
    // animate in 
    animationName: 'fadeInDown',
    animationDelay: '0s',
    animationDuration: '.1s',
    animationFillMode: 'forwards'
  }
};
exports.default = _default;